<template>
  <section class="page-wrap">
    <!-- 搜索模块 start -->
    <section class="form jn-form-style">
      <div class="form-item btn-wrap">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-refresh"
          title="重置"
          jn-refresh-btn
          @click="onRefresh"
        ></el-button>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="结算日期起"
          end-placeholder="结算日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime1"
          @change="changeDate1"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-select
          placeholder="请选择集配中心"
          v-model="formData.logistic_business_id"
          @change="onChangeLogistic"
          filterable
          clearable
        >
          <el-option
            v-for="item of logisticsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-select
          placeholder="请选择城市仓"
          v-model="formData.store_logistics_id"
          @change="onChangeCityStore"
          filterable
          clearable
        >
          <el-option
            v-for="item in cityStoreList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <el-select
          placeholder="请选择自提点"
          v-model="formData.store_delivery_id"
          @change="onHandleSearch"
          filterable
          clearable
        >
          <el-option
            v-for="item in deliveryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="供货日期起"
          end-placeholder="供货日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime2"
          @change="changeDate2"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <div class="form-item">
        <el-input
          placeholder="持卡人姓名"
          v-model="formData.bank_username"
          clearable
        >
        </el-input>
      </div>
      <div class="form-item">
        <el-select
          placeholder="请选择结转状态"
          v-model="formData.status"
          clearable
        >
          <el-option
            v-for="item in overStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="form-item">
        <el-button
          slot="suffix"
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="onHandleSearch"
          >查询</el-button
        >
        <el-button
          @click="onHandleExport"
          :disabled="!dataList.length || disabledExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </div>
    </section>
    <!-- 搜索模块 end -->

    <!-- 列表数据 start -->
    <section class="content" v-loading="loading">
      <table-list :dataList="dataList"></table-list>
      <!-- 分页 start -->
      <el-pagination
        v-if="total"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 end -->
    </section>
    <!-- 列表数据 end -->
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
import TableList from "./modules/table-list";
import {
  getCityReconciliationList,
  getCityReconciliationListExport,
} from "@/api/general/reconciliation-manage/index";
import mock from "./mock";
import { OVER_STATUS } from "./utils/enum";
import { formatDate } from "@/utils/tools/date.js";

export default {
  name: "CityReconciliationManage",
  components: {
    TableList,
  },
  data() {
    return {
      loading: false,
      disabledExport: false, // 导出禁用
      overStatusList: Object.values(OVER_STATUS), // 结转状态下拉
      dataTime1: [], // 时间对象
      dataTime2: [formatDate(), formatDate()], // 时间对象
      formData: {
        logistic_business_id: "", // 集配中心ID
        store_logistics_id: "", // 城市仓ID
        store_delivery_id: "", // 自提点ID
        start_convert_date: "", // 结算日期起
        end_convert_date: "", // 结算日期止
        start_date: formatDate(), // 供货日期起
        end_date: formatDate(), // 供货日期止
        bank_username: "", // 持卡人姓名
        status: "", // 结转状态
        page: 1,
        pageSize: 10,
      }, // 表单数据
      formDataClone: {}, // 拷贝一份数据，用于重置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }, // 时间范围
      dataList: [], // 列表数据
      total: 0,
      logisticsList: [], // 集配中心列表
      cityStoreList: [], // 城市仓列表
      deliveryList: [], // 自提点列表
    };
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    /**
     * 初始化数据
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.getAjaxLogisticsList();
      this.ajaxGetCityStoreList();
      this.onHandleSearch();
    },
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticsList = data;
        console.log("ajax getAjaxLogisticsList", data);
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 查询数据
     */
    onHandleSearch() {
      this.dataList = [];
      this.total = 0;
      this.ajaxGetCityReconciliationList();
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.onHandleSearch();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.onHandleSearch();
    },
    /**
     * 重置表单数据
     */
    onRefresh() {
      this.dataTime1 = [];
      this.dataTime2 = [formatDate(), formatDate()];
      this.deliveryList = [];
      this.formData = {
        ...this.formDataClone,
      };
      this.onHandleSearch();
    },
    /**
     * 获取城市仓列表
     */
    ajaxGetCityStoreList: debounce(async function (data) {
      const params = {
        name: data,
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.logisticsList(params);
        this.cityStoreList = data;
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      }
    }, 500),
    /**
     * 获取自提点列表
     */
    ajaxGetSelfTakeList: debounce(async function ({
      name = "",
      logisticsId = "",
    }) {
      /**
       * 城市仓为必传参数
       * 防止接口在删除城市仓前请求数据，故先判断条件
       */
      if (!logisticsId || !this.formData.store_logistics_id) {
        return;
      }
      const params = {
        name,
        logistics_id: (logisticsId && [logisticsId]) || [],
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.deliverySuper(params);
        this.deliveryList = data;
        console.log("ajx ajaxGetSelfTakeList", data);
      } catch (err) {
        console.log("ajx ajaxGetSelfTakeList err", err);
      }
    },
    500),
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      /** 新导出逻辑 */
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
          user_name: username,
        };
        delete query.page;
        delete query.pageSize;
        await getCityReconciliationListExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax getCityReconciliationListExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 集配中心发生变化
     */
    onChangeLogistic(data) {
      // 重置关联数据
      this.cityStoreList = [];
      this.deliveryList = [];
      this.formData.store_logistics_id = "";
      this.formData.store_delivery_id = "";
      this.ajaxGetCityStoreList();
    },
    /**
     * 城市仓发生变化
     */
    onChangeCityStore(data) {
      // 重置自提点
      this.deliveryList = [];
      this.formData.store_delivery_id = "";
      const params = {
        name: "",
        logisticsId: data,
      };
      this.ajaxGetSelfTakeList(params);
      this.onHandleSearch();
    },
    /**
     * 获得结算详情列表
     */
    async ajaxGetCityReconciliationList() {
      this.loading = true;
      const params = { ...this.formData };
      try {
        const { data } = await getCityReconciliationList(params);
        console.log("ajax getCityReconciliationList", data);
        const { total, data: list } = data;
        this.total = total;
        this.dataList = list;
      } catch (err) {
        // 模拟数据
        const { total, page, pageSize, list } = mock.tableList;
        this.total = total;
        this.pageParams = {
          page,
          pageSize,
        };
        this.dataList = list.concat([...list]);
        console.log("ajax getCityReconciliationList err", err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 日期发生了变化
     */
    changeDate1(data) {
      this.formData.start_convert_date = data?.[0] || "";
      this.formData.end_convert_date = data?.[1] || "";
    },
    /**
     * 日期发生了变化
     */
    changeDate2(data) {
      this.formData.start_date = data?.[0] || "";
      this.formData.end_date = data?.[1] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  height: calc(100% - 12px);
  padding: 6px;
  display: flex;
  flex-direction: column;
  .form {
    padding: 13px 15px;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .el-pagination {
      padding: 10px 10px;
    }
  }
}
</style>
